import { useAuth } from "react-oidc-context";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { createWhatson, editWhatson, Whatson, WhatsonApiPayload, fetchWhatson, fetchWhatsons, getDateTimeFromFormStart, selectWhatsonStatus, setStatus, times } from "../whatsonSlice";
import { clearAlert, infoAlert } from "../../shared/appSlice";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router";
import { useEffect } from "react";

import { isFulfilled } from "@reduxjs/toolkit";
import styled from 'styled-components'
import { InputRow } from "../../shared/components/widgets/InputRow";
import { SelectRow } from "../../shared/components/widgets/SelectRow";
import { Loading } from "../../shared/components/Loading";
import { Alert } from "../../shared/components/Alert";
export const Wrapper = styled.article`
  display: grid;
  place-items: center;
  padding-top: 3rem;
  padding-left: 2rem;
  padding-right: 2rem;
  width: 100%;
  margin-bottom: 2rem;
    

`

/**
 * On browser refresh the WhatsonEditor ends up empty - I think this might be because setValue never gets called (its the only difference I can see between this field and all the rest)
 * @returns 
 */
export const WhatsonEntryForm = () => {
  const { id } = useParams();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const appstate = useAppSelector(state => state.appstate);
  const whatsonstate = useAppSelector(state => state.whatsonstate);
  const whatsonStatus = useAppSelector(selectWhatsonStatus)
  const auth = useAuth();

  const { control, handleSubmit, reset } = useForm<Whatson>({ defaultValues: whatsonstate.whatson });



  
  /*
   A bit complex this - i need to be able to await the exibit fetching, so that i can set the state for the component only after all the data are fetched and pushed into the state
   Even so, this doesn't guarantee that I'm not "setEditorState"-ing before the component has mounted. Need to figure out how to ensure that.
  */
  useEffect(() => {
    const getApiData = async () => {
      const action1 = await dispatch(fetchWhatson({id: id} as WhatsonApiPayload));
      const ex: Whatson = action1.payload as Whatson
      reset(ex)
    }

    dispatch(clearAlert());
    if (id) {
      dispatch(setStatus('pending'))
      getApiData();
    }
  }, [dispatch])


  const onSubmit: SubmitHandler<Whatson> = async (data: Whatson) => {
    //console.trace()
    console.log(data)

    data.startDateTime = getDateTimeFromFormStart(data.day, data.start)

    if (data.id) {

      const payload: WhatsonApiPayload = {accessToken: auth.user?.access_token as string, id: data.id, whatson: data}

      const action1 = await dispatch(editWhatson(payload))
      if (isFulfilled(action1)) {
        dispatch(infoAlert('event updated'));
        const action2 = await dispatch(fetchWhatsons())
        if(isFulfilled(action2)) {
          navigate('/schedule')
        }
      }
  
    } else {
      data.author = auth.user?.profile.preferred_username as string || auth.user?.profile.email as string;
      const payload: WhatsonApiPayload = {accessToken: auth.user?.access_token as string, id: null, whatson: data}

      const action1 = await dispatch(createWhatson(payload))
      if (isFulfilled(action1)) {
        dispatch(infoAlert('event created'));
        const action2 = await dispatch(fetchWhatsons())
        if(isFulfilled(action2)) {
          navigate('/schedule')
        }
      }
    }
  }

  return (
    whatsonStatus === 'pending' ? (
      <Loading centre />
    ) : (
      <Wrapper>
        {appstate.showAlert && <Alert />}

        <form className="default-container" onSubmit={handleSubmit(onSubmit)}>
          <Controller name="title" rules={{ required: 'title is required' }} control={control} render={({ field, formState: {errors} }) => 
            <InputRow {...field} value={field.value} error={errors.title?.message} type="input" className="form-input" label="Title of event *" />} /> 

          <Controller name="vendor" rules={{ required: {value: true, message: 'vendor is required'}}} control={control} render={({ field, formState: {errors} }) =>
            <InputRow {...field} value={field.value} error={errors.vendor?.message} type="input" className="form-input" label="Whatsonor (name or company) *" />} /> 

          <Controller name="location" rules={{ required: 'a location must be selected' }} control={control} render={({ field, formState: {errors} }) =>
            <SelectRow {...field} value={field.value} error={errors.location?.message} list={[{itemValue: 'Port Melbourne'},{itemValue: 'St Kilda'}]} className="form-input" label="Location *" />} /> 

          <Controller name="day" rules={{ required: 'a day must be selected' }} control={control} render={({ field, formState: {errors} }) =>
            <SelectRow {...field} value={field.value} error={errors.day?.message} list={[{itemValue: 'Sat 3rd'},{itemValue: 'Sun 4th'}]} className="form-input" label="Day *" />} /> 

          <Controller name="start" rules={{ required: 'a start time must be selected' }} control={control} render={({ field, formState: {errors} }) =>
            <SelectRow {...field} value={field.value} error={errors.start?.message} list={times} className="form-input" label="Start time *" />} /> 

          <Controller name="minAge" rules={{ required: {value: false, message: ''}, pattern: {value: /^[0-9]*$/, message:'the minimum age should be a number' }}} control={control} render={({ field, formState: {errors} }) =>
            <InputRow {...field} value={field.value} error={errors.minAge?.message} type="input" className="form-input" label="Minimum age" />} /> 

          <button
            type='submit'
            className='btn btn-go'
          >
            Submit
          </button>
        </form>
        
      </Wrapper>
    )

  );
}